import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getOwnerAccBalance } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import AnimationUpAndDown from "../../../BeneTransaction/OwnerPopup/AnimationUpAndDown";
import "./index.css";
// import formatTotalBalance from "../../../utils/formatTotalBalance";
import {
  errorcode,
  GlobalConfiguration,
} from "../../../../utils/configurationProvider";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import CommonToast from "../../../_utils/CommonToast";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import TickerAnimation from "../../../_utils/TickerAnimation";
import ICONS from "../../../../assets/Icons";

function ConnectedBankOwnerCard({
  owner,
  ownerAccounts,
  setOwnerAccounts,
  ownerAccBalanceLoading,
  ownerAccBalanceError,
  updateTotalBalance,
  total_balance,
  connectedBankingOwnerAccounts,
  setConnectedBankingOwnerAccounts,
}) {
  const navigate = useNavigate();
  const [accId, setAccId] = useState("");
  const services = useSelector((state) => state.refreshToken.services);
  const [currentConnectedBal, setCurrentConnectedBal] = useState("");
  const [prevConnectedBal, setPrevConnectedBal] = useState("");
  const [refreshedConnectedId, setRefreshedConnectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const requiredServices =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  const dispatch = useDispatch();

  const handleRefresh = async (id) => {
    CommonToast({
      text: "Refreshing balance",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
    });
    setIsLoading(true);
    try {
      let response = await dispatch(getOwnerAccBalance(id));
      if (response?.payload?.status === true) {
        setRefreshedConnectedId(id);
        let updatedOwnersData = ownerAccounts?.map((item) => {
          if (
            response?.payload?.owner_accounts[0]?.owner_account_id === item?.id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response?.payload?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response?.payload?.owner_accounts[0]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response.payload?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });

        const updatedConnectedBankingData = connectedBankingOwnerAccounts?.map(
          (item) => {
            if (
              response?.payload?.owner_accounts[0]?.owner_account_id ===
              item?.id
            ) {
              return {
                ...item,
                owner_account_balance_last_fetched_at_in_words:
                  response?.payload?.owner_accounts[0]
                    ?.owner_account_balance_last_fetched_at_in_words,
                owner_account_balance:
                  response?.payload?.owner_accounts[0]?.owner_account_balance,
                owner_account_balance_last_fetched_at:
                  response.payload?.owner_accounts[0]
                    ?.owner_account_balance_last_fetched_at,
              };
            }
            return item;
          },
        );

        setOwnerAccounts(updatedOwnersData);
        setConnectedBankingOwnerAccounts(updatedConnectedBankingData);

        const prevBalance = connectedBankingOwnerAccounts?.find(
          (owner) => owner.id === id,
        )?.owner_account_balance;

        setPrevConnectedBal(prevBalance);

        const refreshedBalance = response?.payload.owner_accounts.find(
          (owner) => owner.owner_account_id === id,
        )?.owner_account_balance;

        setCurrentConnectedBal(refreshedBalance);

        const updatedConnectedBankingTotal =
          Number(total_balance) -
          Number(prevBalance) +
          Number(refreshedBalance);

        updateTotalBalance(String(updatedConnectedBankingTotal));
      } else {
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, errorcode.errorFailed);
      }
    } catch (error) {
      CommonToast({
        text: error,
        toast_position,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  const service =
    !services?.includes("VAccountBalance") && !services?.includes("Admin");
  return (
    <div
      className={
        " flex flex-row justify-between  items-center  relative cursor-pointer  opacity-base-opacity w-full  bg-primary-nav rounded-border-radius-sm py-padding-xs px-padding-sm  z-z-index-base global-hover-white"
      }
      onClick={() => {
        navigate(
          `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owner?.id}`,
        );
      }}
    >
      <AnimationUpAndDown
        loader={ownerAccBalanceLoading}
        currentId={refreshedConnectedId}
        previousId={owner?.id}
        currentBalance={currentConnectedBal}
        previousBalance={prevConnectedBal}
        refreshType={"single"}
        classType={"owner_connected"}
      />

      <div
        title={owner.bank_acc_no}
        className="  border-r-border border-primary-bg  flex flex-col gap-gap-xs min-w-standard-account-min-width pr-padding-md flex-shrink-0"
      >
        <p className="text-text-primary text-font-xs font-normal">
          {" "}
          {owner.bank_acc_no.substring(0, 4) +
            " •••• " +
            owner.bank_acc_no.substring(owner.bank_acc_no.length - 4)}
        </p>
        <p className="text-text-secondary text-font-xxs font-normal">
          Account number
        </p>
      </div>

      <div className="flex w-full  justify-end  gap-gap-sm overflow-hidden">
        <div className="flex flex-col gap-y-gap-xs   items-end justify-between gap-gap-sm w-width-lg ">
          {/* <p
            className={`text-font-xs ${
              owner?.owner_account_balance
                ? owner?.owner_account_balance <
                    GlobalConfiguration?.lengthCheckZero &&
                  !(
                    isNaN(owner.owner_account_balance) ||
                    owner.owner_account_balance === "xxxx.xx" ||
                    owner.owner_account_balance === null ||
                    owner.owner_account_balance === undefined
                  )
                  ? "text-failed font-semibold"
                  : "text-settled font-semibold"
                : "text-text-primary font-normal"
            }`}
          >
            {isNaN(owner.owner_account_balance) ||
            owner.owner_account_balance === "xxxx.xx" ||
            owner.owner_account_balance === null ||
            owner.owner_account_balance === undefined ? (
              "Not available"
            ) : (
              <>
                {"INR " +
                  formatTotalBalance(Number(owner?.owner_account_balance))
                    .amount +
                  " " +
                  formatTotalBalance(Number(owner?.owner_account_balance)).abbr}
              </>
            )}
          </p> */}

          <p
            className={`text-font-sm flex-1 truncate ${
              owner?.owner_account_balance
                ? owner?.owner_account_balance <
                  GlobalConfiguration.lengthCheckZero
                  ? "text-failed font-semibold"
                  : "text-settled font-semibold"
                : "text-text-primary font-normal"
            }`}
          >
            {owner?.owner_account_balance
              ? `
                      ${shouldBeRedacted(owner?.owner_account_balance) ? "" : "INR "}
                      ${
                        formatTotalBalance(Number(owner?.owner_account_balance))
                          .amount
                      }
                       ${formatTotalBalance(Number(owner?.owner_account_balance)).abbr}
                   `
              : "Not available"}
          </p>

          <p className="text-font-xxs text-text-secondary min-w-0  font-normal flex-1 truncate  max-w-24">
            <TickerAnimation
              text={
                owner?.owner_account_balance_last_fetched_at_in_words &&
                requiredServices
                  ? `Balance - ${owner?.owner_account_balance_last_fetched_at_in_words}`
                  : "Balance"
              }
            />
          </p>
        </div>
        {isLoading && accId === owner?.id ? (
          <div className="my-auto ">
            <img
              src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
              alt=""
              className="h-icon-sm w-icon-sm flex-shrink-0 "
            />
          </div>
        ) : !isLoading && !ownerAccBalanceError && accId === owner?.id ? (
          <div className="my-auto ">
            <img
              src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
              alt=""
              className="h-icon-sm w-icon-sm flex-shrink-0 "
            />
          </div>
        ) : owner?.connected_banking === "Y" && requiredServices ? (
          <div className="my-auto">
            {!service && (
              <>
                <CardActionableButton
                  btnType="button"
                  handleFunction={(e) => {
                    if (
                      services?.includes("VAccountBalance") ||
                      services?.includes("Admin")
                    ) {
                      e.stopPropagation();
                      handleRefresh(owner?.id);
                      setAccId(owner?.id);
                    } else {
                      e.stopPropagation();
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "VAccountBalance,Admin" },
                      });
                    }
                  }}
                  isDisabled={
                    !services?.includes("VAccountBalance") &&
                    !services?.includes("Admin")
                  }
                  bgColor="var(--primary-bg)"
                  disabledBgColor="var(--primary-nav-act)"
                  icon="https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg"
                  hoverOption="white"
                  title="Refresh"
                />
              </>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default ConnectedBankOwnerCard;
